var _style, _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 142 142",
    style: {
      enableBackground: "new 0 0 142 142"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{clip-path:url(#SVGID_2_);} .st1{fill:#5C6B73;} .st2{fill:url(#SVGID_3_);} ")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 141.3,
    height: 141.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.4,102.9c4.4-3.8,7.3-9.4,7.3-15.7c0-11.4-9.3-20.7-20.7-20.7c-11.4,0-20.7,9.3-20.7,20.7 c0-11.4-9.3-20.7-20.7-20.7c-11.4,0-20.7,9.3-20.7,20.7c0,6.3,2.8,11.9,7.3,15.7c-2.7,1.4-5.1,3.3-7.2,5.4c-2.1-2.2-4.6-4-7.3-5.4 c4.4-3.8,7.3-9.4,7.3-15.7c0-11.4-9.3-20.7-20.7-20.7S8.5,75.8,8.5,87.2c0,6.3,2.8,11.9,7.3,15.7C6.6,107.8,0,117.5,0,128.9v8.3 c0,2.3,1.8,4.1,4.1,4.1c1.6,0,130.3,0,133,0c2.3,0,4.1-1.9,4.1-4.1v-8.3C141.3,117.6,134.7,107.8,125.4,102.9z M112,74.8 c6.8,0,12.4,5.6,12.4,12.4c0,6.8-5.6,12.4-12.4,12.4s-12.4-5.6-12.4-12.4S105.2,74.8,112,74.8z M91.3,87.2 c0,6.3,2.8,11.9,7.3,15.7c-2.7,1.4-5.2,3.2-7.3,5.4c-2.1-2.2-4.5-4-7.2-5.4C88.5,99.2,91.3,93.5,91.3,87.2z M70.6,74.8 c6.8,0,12.4,5.6,12.4,12.4c0,6.8-5.6,12.4-12.4,12.4c-6.8,0-12.4-5.6-12.4-12.4C58.2,80.4,63.8,74.8,70.6,74.8z M29.2,74.8 c6.8,0,12.4,5.6,12.4,12.4c0,6.8-5.6,12.4-12.4,12.4s-12.4-5.6-12.4-12.4S22.4,74.8,29.2,74.8z M41.7,128.9v4.1H8.2v-4.1 c0-11.4,9.6-21,21-21c6.1,0,11.9,2.7,15.8,7.3C42.9,119.3,41.7,123.9,41.7,128.9z M91.4,133H49.9v-4.1c0-11.6,9.3-21,20.7-21 c11.4,0,20.8,9.4,20.8,21L91.4,133z M133.1,133H99.6v-4.1c0-4.9-1.2-9.6-3.4-13.7c3.9-4.6,9.7-7.3,15.8-7.3c11.4,0,21,9.6,21,21 V133z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.6611,
    y1: 121.9677,
    x2: 104.2256,
    y2: 91.0199,
    gradientTransform: "matrix(1 0 0 -1 0 142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEA860"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA6661"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.9,19.3L81,17L73.9,2.3c-1.5-3.1-5.9-3.1-7.4,0L59.4,17l-15.9,2.3c-3.4,0.5-4.7,4.7-2.3,7.1l11.5,11.2 L50,53.4c-0.6,3.4,3,6,6,4.4l14.2-7.5l14.2,7.5c3,1.6,6.6-1,6-4.4l-2.7-15.8l11.5-11.2C101.7,24,100.3,19.8,96.9,19.3z M80.4,33.2 c-1,1-1.4,2.3-1.2,3.7l1.7,9.7l-8.7-4.6c-1.2-0.6-2.6-0.6-3.9,0l-8.7,4.6l1.7-9.7c0.2-1.3-0.2-2.7-1.2-3.7L53,26.3l9.7-1.4 c1.4-0.2,2.5-1.1,3.1-2.3l4.3-9l4.3,9c0.6,1.2,1.8,2.1,3.1,2.3l9.7,1.4L80.4,33.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalent);
export default __webpack_public_path__ + "static/media/talent.6b0a8616b1ca8215c21f014ac1f4b3fb.svg";
export { ForwardRef as ReactComponent };